import { render, staticRenderFns } from "./GitPullWizard.vue?vue&type=template&id=6a54a462"
import script from "./GitPullWizard.vue?vue&type=script&lang=js"
export * from "./GitPullWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports